var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCompany(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Navigation / Building_02"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.66663 16.6673H3.33329M3.33329 16.6673H9.99996M3.33329 16.6673V6.00081C3.33329 5.06739 3.33329 4.60033 3.51495 4.24382C3.67474 3.93021 3.92952 3.67543 4.24312 3.51564C4.59964 3.33398 5.0667 3.33398 6.00012 3.33398H7.33346C8.26688 3.33398 8.73334 3.33398 9.08986 3.51564C9.40347 3.67543 9.65869 3.93021 9.81848 4.24382C9.99996 4.59999 9.99996 5.06648 9.99996 5.99808V8.53906M9.99996 16.6673H16.6666M9.99996 16.6673V8.53906M16.6666 16.6673H18.3333M16.6666 16.6673V11.9741C16.6666 11.5365 16.6666 11.3173 16.6141 11.1131C16.5676 10.9322 16.4907 10.7605 16.3872 10.605C16.2704 10.4295 16.1079 10.283 15.7822 9.9904L13.8655 8.26847C13.2355 7.70248 12.9204 7.41961 12.5643 7.31226C12.2505 7.2177 11.9158 7.2177 11.6021 7.31226C11.246 7.41959 10.931 7.70261 10.3011 8.26847L9.99996 8.53906",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompany);
export default __webpack_public_path__ + "static/media/company.dd8914c314c7d00c913c728ecfc017c7.svg";
export { ForwardRef as ReactComponent };